import { AVAILABLE_SERVICE } from './consultation'
import { REMINDER_TYPES, ReminderConfig } from './reminder'
import { Theme } from './theme'

export enum FEATURE {
  ASK_PHONE_FOR_REMINDER = 'askPhoneForReminder',
  HEALTH_NAVIGATOR_MESSAGE_FEEDBACK = 'healthNavigatorMessageFeedback',
  HEALTH_NAVIGATOR_CONVERSATION_FEEDBACK = 'healthNavigatorConversationFeedback',
  HEALTH_NAVIGATOR_ONLY = 'healthNavigatorOnly',
  GOAPP_EXTERNAL_CASE_CREATION = 'goAppExternalCaseCreation'
}

export enum FULFILLMENT_OPTION {
  DELIVERY = 'delivery',
  COLLECT = 'collect',
  PDF = 'pdf'
}

export interface Config {
  reminders?: { [key in REMINDER_TYPES]?: ReminderConfig[] }

  theme?: Theme

  meta?: {
    title?: string
    description?: string
  }

  consultation?: {
    availableServices: AVAILABLE_SERVICE[]
    fulfillmentOptions?: FULFILLMENT_OPTION[]
  }

  features?: FEATURE[]
  defaultValues?: {
    language?: string
    country?: string
  }

  tagManagerEnabled?: boolean
  translationKey?: string
}
